import { throttle } from "lodash-es";

window.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".js-fix-nav");

  function fixNav() {
    if (nav && window.pageYOffset > 35) nav.classList.add("is-fixed");
    else nav.classList.remove("is-fixed");
  }

  window.addEventListener(
    "scroll",
    throttle(() => {
      fixNav();
    }, 50)
  );
});
